import types from "./types";
import _ from "lodash";

const setOrders = orders => {
  localStorage.setItem("orders", JSON.stringify(orders));
};

const setCurrentUser = id => {
  localStorage.setItem("orderUser", id.toString());
};

const jsonParse = data => JSON.parse(JSON.stringify(data));

export default {
  [types.ORDER_SET_BY_INDEX]: function(state, payload) {
    const { index, order } = payload;
    state.orders[index] = jsonParse(order);
    state.orders = jsonParse(state.orders);
    setOrders(state.orders);
  },
  [types.ORDER_ADD_SCHEDULE]: function(state, payload) {
    state.orders.push(payload);
    setOrders(state.orders);
  },
  [types.ORDER_REMOVE_SCHEDULE]: function(state, payload) {
    const { index } = payload;
    state.orders.splice(index, 1);
    setOrders(state.orders);
  },
  [types.ORDER_SET]: function(state, payload) {
    state.orders = payload;
    setOrders(state.orders);
  },
  [types.ORDER_SET_CURRENT_USER]: function(state, payload) {
    state.orderCurrentUser = payload;
    setCurrentUser(state.orderCurrentUser);
  },
  [types.FETCH_CATEGORY_PAGINATE]: (state, payload) => {
    const { page } = state.categoryMeta;
    state.categories = _.uniqBy([...state.categories, ...payload.data], "id");
    state.categoryMeta = {
      page: page + 1,
      hasNextPage: payload.meta.hasNextPage
    };
  },
  [types.CATEGORY_LIST_RESET]: state => {
    state.categories = [];
    state.categoryMeta = {
      page: 1,
      hasNextPage: true
    };
  },
  [types.FETCH_LOCATION_PAGINATE]: (state, payload) => {
    const { page } = state.locationMeta;
    state.locations = _.uniqBy([...state.locations, ...payload.data], "id");
    state.locationMeta = {
      page: page + 1,
      hasNextPage: payload.meta.hasNextPage
    };
  },
  [types.LOCATION_LIST_RESET]: state => {
    state.locations = [];
    state.locationMeta = {
      page: 1,
      hasNextPage: true
    };
  },
  [types.SET_INVALID_ORDER]: (state, payload) => {
    state.invalidOrder = payload;
  }
};
